import { Component, input, output } from '@angular/core';
import { Project } from '@app/models/project.models';
import { TranslateModule } from '@ngx-translate/core';
import {
  ProjectDisplayType,
  ProjectVerticalCardComponent,
} from '../project-vertical-card/project-vertical-card.component';

@Component({
  selector: 'app-project-list',
  standalone: true,
  templateUrl: './project-list.component.html',
  styleUrl: './project-list.component.scss',
  imports: [ProjectVerticalCardComponent, TranslateModule],
})
export class ProjectListComponent {
  public projects = input.required<Project[]>();
  public displayType = input.required<ProjectDisplayType>(); //TODO: based on this show different type of cards with different details
  public isLoading = input(false);

  public onDetailsClicked = output<string>();
}
